// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import DesAwFileDirUpload from 'viewmodel/DesAwFileDirUploadViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import { EnableWhen, AwClass } from 'js/hocCollection';
const AwButtonEnableWhenAwClass = AwClass(EnableWhen(AwButton));
AwButtonEnableWhenAwClass.displayName = 'AwButtonEnableWhenAwClass';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/importDataUploadService', () => import('js/importDataUploadService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "lifecycleHooks": {
    "onMount": "executeOnMountBatchAction",
    "onUnmount": "removeEvents"
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "containerid": {
      "type": "string"
    },
    "containertype": {
      "type": "string"
    },
    "folderid": {
      "type": "string"
    },
    "stagingareatype": {
      "type": "string"
    }
  },
  "data": {
    "directory": true,
    "taskInfo": "",
    "uploadStatus": "TO_BE_STARTED",
    "statusMap": {
      "INIT": "INIT",
      "FAILED": "FAILED",
      "ERROR": "VALIDATION_FAILED"
    },
    "createStagingAreaObject": {},
    "metadata": {}
  },
  "actions": {
    "registerFileUploadWorker": {
      "actionType": "JSFunctionAsync",
      "method": "registerFileUploadWorker",
      "inputData": {
        "parameters": "{{data}}",
        "pending": "{{props}}"
      },
      "deps": "js/importDataUploadService"
    },
    "updateSelectedFileInfoAction": {
      "actionType": "JSFunctionAsync",
      "method": "getSelectedFileInfo",
      "inputData": {
        "parameters": "{{parameters}}",
        "pending": "{{i18n.pending}}"
      },
      "outputData": {
        "dataToBeRelated": "dataToBeRelated",
        "fileInputForms": "fileInputForms"
      },
      "deps": "js/importDataUploadService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventName}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "executeOnMountBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "publishAccInitEvent"
      }, {
        "action": "subscribeEvents"
      }]
    },
    "subscribeEvents": {
      "actionType": "JSFunction",
      "method": "subscribeEvents",
      "inputData": {
        "toggle": true,
        "vmo": "{{data}}"
      },
      "deps": "js/importDataUploadService"
    },
    "removeEvents": {
      "actionType": "JSFunction",
      "method": "subscribeEvents",
      "inputData": {
        "toggle": false,
        "vmo": "{{data}}"
      },
      "deps": "js/importDataUploadService"
    },
    "publishAccInitEvent": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "des-import-data.initialized",
        "eventData": true
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [],
  "conditions": {
    "validFile": {
      "expression": "data.dataToBeRelated.attachFiles.length > 0"
    },
    "uploadInitiated": {
      "expression": "( data.uploadStatus === data.statusMap.INIT || data.uploadStatus === data.statusMap.ERROR )"
    },
    "uploadFailed": {
      "expression": "data.uploadStatus === data.statusMap.FAILED"
    }
  },
  "messages": {},
  "i18n": {
    "upload": ["DesImportDataMessages"],
    "CancelText": "Cancel",
    "removeFileBtnTooltip": "remove this file",
    "uploading": ["DesImportDataMessages"],
    "uploadFailed": ["DesImportDataMessages"],
    "failedToUploadFiles": ["DesImportDataMessages"],
    "pending": ["DesImportDataMessages"],
    "import": ["DesImportDataMessages"],
    "uploadError": ["DesImportDataMessages"],
    "uploaded": ["DesImportDataMessages"],
    "fileUploadSuccess": ["DesImportDataMessages"],
    "resourceBusyWarning": ["DesImportDataMessages"],
    "uploadCompleted": ["DesImportDataMessages"],
    "emptyEventDataFound": ["DesImportDataMessages"],
    "metaDataReadError": ["DesImportDataMessages"]
  },
  "_viewModelId": "DesImportData",
  "_uniqueViewModelId": "DesImportData",
  "ctx": {}
};

/*
<aw-panel class="aw-file-dir-upload-panel aw-layout-full">
    <aw-panel-body>
        <aw-panel-section caption="i18n.fileAttachTitle">
            <des-aw-file-dir-upload file-change-action="updateSelectedFileInfoAction" multiple="{{true}}"
                webkitdirectory="{{data.directory}}"
                remove-tooltip="{{i18n.removeFileBtnTooltip}}"></des-aw-file-dir-upload>
        </aw-panel-section>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button 
            aw-class="[{ 'disabled': conditions.uploadInitiated }]"
            enable-when="conditions.validFile" 
            action="registerFileUploadWorker" size="auto">{{ conditions.uploadInitiated ? i18n.uploading : i18n.upload}}
        </aw-button>
    </aw-panel-footer>
</aw-panel>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal,
    className: "aw-file-dir-upload-panel aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwPanelBody, null, /*#__PURE__*/React.createElement(AwPanelSection, {
    caption: i18n.fileAttachTitle
  }, /*#__PURE__*/React.createElement(DesAwFileDirUpload, {
    fileChangeAction: actions.updateSelectedFileInfoAction,
    multiple: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    webkitdirectory: AwParseService.instance("data.directory")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    removeTooltip: AwParseService.instance("i18n.removeFileBtnTooltip")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))), /*#__PURE__*/React.createElement(AwPanelFooter, null, /*#__PURE__*/React.createElement(AwButtonEnableWhenAwClass, {
    action: actions.registerFileUploadWorker,
    size: "auto",
    enableWhen: AwParseService.instance("conditions.validFile")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    awClass: AwParseService.instance("[{ 'disabled': conditions.uploadInitiated }]")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, AwParseService.instance("conditions.uploadInitiated ? i18n.uploading : i18n.upload")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;